import { render, staticRenderFns } from "./Observacoes.vue?vue&type=template&id=2ab683de&"
import script from "./Observacoes.vue?vue&type=script&lang=js&"
export * from "./Observacoes.vue?vue&type=script&lang=js&"
import style0 from "./Observacoes.vue?vue&type=style&index=0&id=2ab683de&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports